export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";